import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";

import PrepareDataTable from "./PrepareDataTable";
import { CompanyListContainer, Title } from "./CompanyList.styled";

import "./CompanyList.scss";

/**
 * CompanyList List,
 * Path - /companies
 * @see See [CompanyList Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/1855717416/Company+list)
 * @component
 */
const CompanyList = (props) => {
  const { t, columnList } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [adminList, setAdminList] = useState([]);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <CompanyListContainer className="company-list">
      <Title>{t("COMPANIES")}</Title>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        columnList={columnList}
      />
    </CompanyListContainer>
  );
};

CompanyList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyList);
